import { mapGetters, mapMutations, mapActions } from "vuex";

export const appointmentDetailMixin = {
  computed: {
    ...mapGetters({
      details: "getDetail", // Get details of all the appointments
      getDeletedAppointment: "getDeletedAppointment", // Check if appointment has been deleted for changing page
      getChangeToEdit: "getChangeToEdit" // Check when we can change to add appointment to prevent fetching data twice
    }),
    id() {
      return !isNaN(this.$route.params.id)
        ? parseInt(this.$route.params.id)
        : false;
    },
    /**
     * Detail for this partcular appointment
     */
    detail() {
      return this.id && this.id in this.details ? this.details[this.id] : false;
    },
    /**
     * Set the current year, month and date for going to monthly and yearly calendar
     */
    currentYearMonthDate() {
      if (this.detail) {
        const dateArray = this.detail["app_date"].split("-");
        return {
          year: parseInt(dateArray[0]),
          month: parseInt(dateArray[1] - 1),
          dayOfMonth: parseInt(dateArray[2])
        };
      } else {
        const date = new Date();
        return {
          year: date.getFullYear(),
          month: date.getMonth(),
          dayOfMonth: date.getDate()
        };
      }
    }
  },
  methods: {
    ...mapMutations({
      setYear: "setYear", // Setting current selected year
      setMonth: "setMonth", // Setting current selected month
      setDayOfMonth: "setDayOfMonth" // Setting the day of the month
    }),
    ...mapActions({
      setEdit: "setEditAction"
    }),
    /**
     * Go to daily view
     */
    returnToDaily() {
      const yearMonthDate = this.currentYearMonthDate;
      this.setYear(yearMonthDate.year);
      this.setMonth(yearMonthDate.month);
      this.setDayOfMonth(yearMonthDate.dayOfMonth);
      this.$router.push("/daily");
    }
  }
};
